import Image from 'next/image'

type Props = { title: string; bgColor: string }

function ContentMarketingQuotes({ title, bgColor }: Props) {
  return (
    <section style={{ background: bgColor }}>
      <div className="container | py-5 md:py-9">
        <div className="font-heading grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-8 items-center justify-center">
          <div className="md:text-left | md:col-span-7 | md:pr-14">
            <h2
              className="text-3xl font-semibold lg:text-4xl tracking-tight | mb-4"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </div>
          <div className="md:col-start-9 md:col-end-13 mx-auto relative">
            <Image
              src="/assets/blog/content_marketing_quote.svg"
              alt=""
              width={301}
              height={289}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContentMarketingQuotes
